<template>
  <div
    :style="{ marginTop: marginTop + 'px' }"
    class="lv-input-textarea-button"
    :class="{ blueBg: blueBg }"
  >
    <div v-if="title" class="input-textarea-button_title-wrap">
      <p class="input-textarea-button_title" :class="{ bigTitle: bigTitle }">
        {{ $t(title) }}<span v-if="required" class="required">*</span>
      </p>
      <span v-if="maxLength" class="text-number"
        >{{ value ? value.length : 0 }}/{{ maxLength }}</span
      >
      <div v-if="$slots.button" class="button">
        <slot name="button" />
      </div>
    </div>
    <ValidationProvider v-slot="{ errors }" :rules="rules" class="input-textarea-button_wrap">
      <div
        class="input-textarea-button_btn"
        :class="{
          textOnly: textOnly,
          bold: bold,
          small: small,
          error: errors.length > 0,
          noErrorText: noErrorText,
        }"
      >
        <input type="hidden" :value="value" />
        <textarea-autosize
          :min-height="minHeight"
          :max-height="maxHeight"
          :value="value"
          :disabled="disabled"
          :placeholder="$t(placeholder)"
          :maxlength="maxLength"
          @input="changeValue($event)"
        />
        <div v-if="errors.length > 0 && !noErrorText" class="invalid-text">
          <i class="icon-warning invalid-icon" />
          <p v-for="(text_e, text_k) in errors" :key="text_k" class="text">
            {{ $t(text_e) }}
          </p>
        </div>
      </div>
    </ValidationProvider>
    <slot name="images" />
    <slot name="attaches" />
  </div>
</template>
<script>
import { ValidationProvider } from 'vee-validate';
import { extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
extend('required', {
  ...required,
  message: '此項目為必填',
});
export default {
  name: 'InputTextareaButton',
  components: {
    ValidationProvider,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    minHeight: {
      type: Number,
      default: 90,
    },
    maxHeight: {
      type: Number,
      default: 300,
    },
    textOnly: {
      type: Boolean,
      default: false,
    },
    bold: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: String,
      default: '',
    },
    marginTop: {
      type: Number,
      default: 0,
    },
    bigTitle: {
      type: Boolean,
      default: false,
    },
    blueBg: {
      type: Boolean,
      default: false,
    },
    noErrorText: {
      type: Boolean,
      default: false,
    },
    maxLength: {
      type: Number,
      default: 3000,
    },
  },
  computed: {},
  methods: {
    changeValue(e) {
      this.$emit('input', e);
    },
  },
};
</script>
<style lang="scss">
@import '@/assets/scss/component/input-textarea-button';
</style>
